module.exports = __webpack_public_path__ + "static/media/RH77M.ee3a71d3.jpg";